module.exports = __webpack_public_path__ + "img/pic1.091411eb.png";